import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=d66afb3a&"
import script from "./DeleteModal.vue?vue&type=script&lang=js&"
export * from "./DeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d66afb3a')) {
      api.createRecord('d66afb3a', component.options)
    } else {
      api.reload('d66afb3a', component.options)
    }
    module.hot.accept("./DeleteModal.vue?vue&type=template&id=d66afb3a&", function () {
      api.rerender('d66afb3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Wordpress/Modals/DeleteModal.vue"
export default component.exports